export default __webpack_public_path__ + "static/media/371.e370526c.jpg";